import { TabsContent } from '@radix-ui/react-tabs'

export const Content = TabsContent
